import { ChevronRightIcon } from "@/components/icons/chevronRight.icon";
import { QueryLink } from "@/components/queryLink/queryLink.component";
import { Text } from "@/components/text/text.component";

import {
  MONITORING_SYSTEM_DRAWER_DEFAULT_SLUG,
  MONITORING_SYSTEM_DRAWER_SEARCH_PARAM,
} from "@/app/blu/monitoring/constants";

import type { FlexibleMonitoringAppPlanSlotData } from "./flexibleMonitoringAppPlanCard.component";

export function PlanEyebrow({
  plan,
}: {
  plan: FlexibleMonitoringAppPlanSlotData;
}) {
  const label = plan.labelAbovePlanTitle?.trim() || "";
  const systemDrawerProductId =
    plan.productId?.trim() || MONITORING_SYSTEM_DRAWER_DEFAULT_SLUG;

  if (label && plan.labelOpensSystemDrawer) {
    return (
      <QueryLink
        set={{ [MONITORING_SYSTEM_DRAWER_SEARCH_PARAM]: systemDrawerProductId }}
        aria-label={`${label}: open system details`}
        className="mx-auto mb-0 flex max-w-prose cursor-pointer items-center gap-1 underline-offset-2 hover:underline">
        <Text
          variant="body4"
          component="span"
          className="text-greyscale-body text-center underline">
          {label}
        </Text>
        <ChevronRightIcon width={16} height={16} className="mb-0.5 shrink-0" />
      </QueryLink>
    );
  }

  if (label) {
    return (
      <Text
        variant="body4"
        component="p"
        className="text-greyscale-body mx-auto mb-0 max-w-prose text-center">
        {label}
      </Text>
    );
  }

  return null;
}
